var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddNewVoteIconComleteStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31.2558,
    height: 32,
    rx: 15.6279,
    fill: "#4ED4A9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5885_202968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1276 19.5003L9.6276 16.0003L8.46094 17.167L13.1276 21.8337L23.1276 11.8337L21.9609 10.667L13.1276 19.5003Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5885_202968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(5.62793 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewVoteIconComleteStep);
export default __webpack_public_path__ + "static/media/AddNewVoteIconComleteStep.97a22b2d38d7e564206a58b0a4b26ecb.svg";
export { ForwardRef as ReactComponent };